export default __webpack_public_path__ + "static/media/back_1_3.c9940cc2.png";